import { Input } from "antd";
import React, { useState, FC, useEffect } from "react";

interface ActivityGoalsInputProps {
  value?: string[];
  onChange?: (value: string[]) => void;
}

export const ZipCodesInput: FC<ActivityGoalsInputProps> = ({ value = [], onChange }) => {
  const [model, setModel] = useState((value || []).join("\n"));

  useEffect(() => {
    setModel((value || []).join("\n"));
  }, [value]);

  const change = (value) => {
    setModel(value);
  };
  const blur = () => {
    onChange && onChange(model.split("\n"));
  };

  return (
    <div style={{  }}>
      <Input.TextArea
        rows={12}
        value={model}
        onChange={(e) => change(e.target.value || "")}
        onBlur={() => blur()}
      ></Input.TextArea>
      <p style={{ marginLeft: 10, color: "gray" }}>Enter zip codes separated by new line</p>
    </div>
  );
};
